import PropTypes from "prop-types";
import React from "react";

import { cssValueType } from "../../services/types.service";
import buildAssetsUrl from "../../util/strings/buildAssetsUrl";

export const PSPIcon = (props) => {
  const { provider } = props;
  const style = {
    height: props.height,
    width: props.width,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <div style={style}>
      <img
        style={{ maxWidth: "100%", maxHeight: "100%" }}
        src={buildAssetsUrl(`pspicons/${provider}`)}
        alt={provider}
      />
    </div>
  );
};

PSPIcon.propTypes = {
  height: cssValueType,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  provider: PropTypes.string,
};

PSPIcon.defaultProps = {
  height: 43,
  width: 43,
  provider: "",
};
